export enum Shadows {
  'OUTLINE' = 'outline',
  'OUTLINE_ERROR' = 'outline-error',
  'BUTTON' = 'button',
  '2XS' = '2xs',
  'XS' = 'xs',
  'BASE' = 'base',
  'SM' = 'sm',
  'MD' = 'md',
  'LG' = 'lg',
  'XL' = 'xl',
  'INNER' = 'inner',
  'KBD_INNER' = 'kbd-inner',
  'DARK_LG' = 'dark-lg',
  'NONE' = 'none',
  'ELEVATIONS.0' = 'elevations.0',
  'ELEVATIONS.1' = 'elevations.1',
  'ELEVATIONS.2' = 'elevations.2',
  'ELEVATIONS.3' = 'elevations.3',
  'ELEVATIONS.4' = 'elevations.4',
  'ELEVATIONS.5' = 'elevations.5',
}
